import styled, { css } from 'styled-components';
import Colors from 'library/constants/colors';
import { TransitionConfig } from '../constants/styles-config';

export const Paragraph = styled.div`
  margin: 2px 0;
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.colors.shade03};
`;

export const ParagraphMediumStyles = css`
  font-size: 16px;
  line-height: 24px;
`;

export const ParagraphMedium = styled.p`
  ${ParagraphMediumStyles};
`;

export const ParagraphSmallStyles = css`
  font-size: 14px;
  line-height: 21px;
`;

export const Header4 = styled.h4`
  margin: 0;
  font-size: 18px;
  line-height: 24px;
`;

export const Header5 = styled.h5`
  margin: 0;
  font-size: 15px;
  line-height: 1.4;
`;

export const ExtraMenu = styled.span`
  font-size: 12px;
  line-height: 16px;
`;

export const CardName = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  font-size: 14px;
  line-height: 17px;
`;

export const TableHeader = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  font-size: 12px;
  line-height: 1.4;
`;

export const Title = styled.h3`
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  color: ${Colors.shade01};
  margin: 0 0 8px 0;
`;

export const InputText = css`
  font-size: 16px;
  font-weight: normal;
  color: ${Colors.shade01};
  transition: box-shadow ${TransitionConfig};
`;

export const InputPlaceholder = styled.span`
  ${InputText};
`;

export const ButtonMid = css`
  font-size: 15px;
  font-weight: bold;
`;

export const ErrorContainer = styled.div`
  ${ParagraphSmallStyles};
  color: ${Colors.error};
  margin-bottom: 10px;
`;
